export default __webpack_public_path__ + "static/media/distancenimp.5fcb742f.svg";